<button mat-icon-button class="close-button" (click)="closeDialog()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>

<h1 mat-dialog-title><strong>Generación de Liquidaciones</strong></h1>
<mat-divider></mat-divider>
<br>

<div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" class="position-relative">
  <div class="row">
    <div class="col-lg-4">
      <mat-form-field class="example-full-width">
        <mat-label>Buscar</mat-label>
        <input matInput type="search" (keyup)="applyFilter($event)" placeholder="Buscar por propietario o documento">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-lg-4">
      <form [formGroup]="form">
        <mat-form-field class="full-width">
          <mat-label>Fecha de Cierre</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="fechaCierre" placeholder="Seleccione una fecha"
            required>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="form.controls['fechaCierre'].hasError('required')">
            La fecha es obligatoria
          </mat-error>
        </mat-form-field>
      </form>
    </div>
    <div class="col-lg-4">
      <mat-form-field class="full-width">
        <mat-label>Tipo de Liquidación</mat-label>
        <mat-select [(value)]="tipoLiquidacion">
          <mat-option value="agrupada">Agrupada por Propiedades</mat-option>
          <mat-option value="simple">Propiedades individuales</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <ngx-spinner name="spPropietarios" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom"
    [fullScreen]="false">
  </ngx-spinner>

  <table mat-table [dataSource]="dataSource" [hidden]="!data" matSort matSortStart="asc" class="mat-elevation-z8">

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()"
          [disabled]="dataSource.filteredData.length === 0">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Descripcion Column -->
    <ng-container matColumnDef="descripcion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <mat-icon>person</mat-icon> Propietario
      </th>
      <td mat-cell *matCellDef="let element">
        <span [title]="element.descripcion">{{element.descripcion}}</span>
      </td>
    </ng-container>

    <!-- Documento Column -->
    <ng-container matColumnDef="nroDocumento">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <mat-icon>badge</mat-icon> Documento
      </th>
      <td mat-cell *matCellDef="let element">
        <span [title]="element.nroDocumento">{{element.nroDocumento}}</span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"
      [class.selected-row]="selection.isSelected(row)">
    </tr>
  </table>

  <app-sin-datos [hidden]="data"></app-sin-datos>

  <!-- Hay datos pero el filtro los tapó: el motivo del vacío es otro y por eso
       el mensaje y el icono son distintos. -->
  <app-sin-datos *ngIf="data && dataSource.filteredData.length === 0 && dataSource.data.length > 0"
    icono="filter_list_off"
    mensaje="Ningún resultado coincide con el filtro"
    detalle="Probá con otro texto o limpiá la búsqueda."
    [compacto]="true">
  </app-sin-datos>

  <br>
  <mat-paginator showFirstLastButtons class="paginator" [hidden]="!data || dataSource.filteredData.length === 0"
    [pageSize]="5" [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
  </mat-paginator>
</div>

<mat-divider></mat-divider>

<!-- Información de selección -->
<div class="selection-info" *ngIf="dataSource.filteredData.length > 0"
  style="padding: 8px 16px; background-color: #f5f5f5; font-size: 14px; border-left: 4px solid #009788;">
  <span *ngIf="getSelectedFilteredCount() > 0">
    <mat-icon style="vertical-align: middle; margin-right: 4px; color: #009788;">check_circle</mat-icon>
    <strong>{{getSelectedFilteredCount()}}</strong> de {{dataSource.filteredData.length}} elementos seleccionados
    <span *ngIf="tipoLiquidacion === 'agrupada'" class="ml-2">
      <mat-icon
        style="vertical-align: middle; margin-left: 8px; margin-right: 4px; color: #FF9800;">group_work</mat-icon>
      <small>(Agrupadas por propiedades)</small>
    </span>
    <span *ngIf="tipoLiquidacion === 'simple'" class="ml-2">
      <mat-icon style="vertical-align: middle; margin-left: 8px; margin-right: 4px; color: #4CAF50;">article</mat-icon>
      <small>(Individuales)</small>
    </span>
  </span>
  <span *ngIf="getSelectedFilteredCount() === 0">
    <mat-icon style="vertical-align: middle; margin-right: 4px; color: #757575;">info</mat-icon>
    {{dataSource.filteredData.length}} elementos disponibles - Seleccione al menos uno para continuar
  </span>
</div>

<div mat-dialog-actions style="justify-content: space-between; padding: 16px;">
  <div>
    <button mat-raised-button *appRole="['Contratos.VisualizaLiquidacion']" (click)="visualizaLiquidacion()"
      [disabled]="!canProcessSelection()" color="primary"
      [title]="getSelectedFilteredCount() > 0 ? 'Visualizar liquidaciones de ' + getSelectedFilteredCount() + ' propietarios' : 'Seleccione al menos un propietario'">
      <mat-icon>visibility</mat-icon>
      Visualizar liquidaciones
      <span *ngIf="getSelectedFilteredCount() > 0"> ({{getSelectedFilteredCount()}})</span>
    </button>

    <button mat-raised-button *appRole="['Contratos.GeneraLiquidacion']" (click)="generarLiquidacion()"
      [disabled]="!canProcessSelection()" color="primary" class="ml-2"
      [title]="getSelectedFilteredCount() > 0 ? 'Procesar liquidaciones de ' + getSelectedFilteredCount() + ' propietarios' : 'Seleccione al menos un propietario'">
      <mat-icon>play_circle</mat-icon>
      Iniciar Proceso
      <span *ngIf="getSelectedFilteredCount() > 0"> ({{getSelectedFilteredCount()}})</span>
    </button>
  </div>

  <button mat-button (click)="closeDialog()" color="warn">
    <mat-icon>cancel</mat-icon> Cancelar
  </button>
</div>
